// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bouncer-wrapper {
  display: table;
  margin: 0 auto;
}

.bouncer-wrapper .bouncer {
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./static/BouncerWrapper.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".bouncer-wrapper {\n  display: table;\n  margin: 0 auto;\n}\n\n.bouncer-wrapper .bouncer {\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
